const API_BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('dartom_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_BASE}/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Błąd serwera');
  return data;
}

export const api = {
  login: (email, password) => request('auth/login', { method: 'POST', body: { email, password } }),
  register: (name, email, password, invite_code) => request('auth/register', { method: 'POST', body: { name, email, password, invite_code } }),
  me: () => request('auth/me'),
  getLeaves: () => request('leaves'),
  createLeave: (data) => request('leaves', { method: 'POST', body: data }),
  reviewLeave: (id, status, manager_note) => request(`leaves/${id}/review`, { method: 'PUT', body: { status, manager_note } }),
  deleteLeave: (id) => request(`leaves/${id}`, { method: 'DELETE' }),
  getUsers: () => request('users'),
  forgotPassword: (email) => request('auth/forgot-password', { method: 'POST', body: { email } }),
  resetPassword: (email, token, password) => request('auth/reset-password', { method: 'POST', body: { email, token, password } }),
  changePassword: (old_password, new_password) => request('users/change-password', { method: 'PUT', body: { old_password, new_password } }),
};
